module.exports = __webpack_public_path__ + "img/paad.0209d36.svg";